import { StandardTabs } from '@cimplico/components';
import { useState } from 'react';
import { useIsFirmRole } from '../../../../../hooks/use-is-firm-role';
import FYIEntitiesOnboarding from './onboarding/entities/FYIEntitiesOnboarding';
import FYIGroupsOnboarding from './onboarding/groups/FYIGroupsOnboarding';
import FirmFYIConfig from './onboarding/FirmFYIConfig';

function FirmFYIIntegration(): JSX.Element {
    const { isAdmin } = useIsFirmRole();
    const tabs = isAdmin ? ['Configuration', 'Group Onboarding', 'Entity Onboarding'] : ['Group Onboarding', 'Entity Onboarding'];

    const [tab, setTab] = useState(0);

    return (
        <div className="flex flex-col">
            <StandardTabs tabs={tabs.map((tab) => ({ label: tab }))} onChange={setTab} />
            <div className="mt-2">
                {tab === 0 && <FirmFYIConfig />}
                {tab === 1 && <FYIGroupsOnboarding />}
                {tab === 2 && <FYIEntitiesOnboarding />}
            </div>
        </div>
    );
}

export default FirmFYIIntegration;
